import config from '../../config'

import { useState } from 'react'
import { useCookies } from 'react-cookie'
import { MdDownload } from 'react-icons/md'

import useIsAuthenticated from '../../customhooks/useIsAuthenticated'

import SkipAdsModal from './SkipAdsModal'

import isDateWithinLast30Days from '../../utils/isDateWithinLast30Days'

const ModelCard = ({ name, image, slugUrl, createdAt }) => {
    const [cookies, setCookie, removeCookie] = useCookies()

    const isAuthenticated = useIsAuthenticated()

    const [showSkipAdsModal, setShowSkipAdsModal] = useState(false)

    const isNew = isDateWithinLast30Days(new Date(createdAt))

    return (
        <>
            <div className="col-lg-3 my-3">
                <div className="card h-100 shadow-sm position-relative">
                    <img src={!image ? config.PLACEHOLDER_IMAGE : image} className="card-img-top" />

                    {isNew &&
                        <div className="position-absolute top-0 end-0 m-1">
                            <p className="badge fs-6 special-button">
                                NEW
                            </p>
                        </div>
                    }
                    {/* <div className="position-absolute top-0 end-0 m-1">
                    <div class="row">
                        <div class="col">
                            <MdFavorite />
                        </div>
                        <div class="col">
                            <span class="badge fs-6">
                                <MdElectricBolt className="special-button" />
                            </span>
                        </div>
                    </div>
                </div> */}

                    {/* <div className="card-img-elements">
                    <span class="badge main-color fs-6">Trending</span>
                </div> */}
                    <div className="card-body">
                        <h5 className="card-title text-center">
                            <a className="text-decoration-none text-white" href={'/model/' + slugUrl}>{name}</a>
                        </h5>
                        {/* <a className="card-title text-center fs-5" href={'/model/' + slugUrl}>{name}</a> */}
                        <div className="text-center">
                            {/* <a href={`/generate-download/${slugUrl}`} className="btn btn-primary rounded-4" style={{ width: '100%' }} target={'_blank'}>Download <MdDownload /></a> */}
                            {cookies.SkipAdsModalSeen ?
                                <a href={`/generate-download/${slugUrl}`} className="btn btn-primary rounded-4" style={{ width: '100%' }} target={'_blank'}>Download <MdDownload /></a> :
                                <button className="btn btn-primary rounded-4" style={{ width: '100%' }}
                                    onClick={() => {
                                        setShowSkipAdsModal(true)
                                        setCookie('SkipAdsModalSeen', 'true', {
                                            path: '/'
                                        })
                                    }}
                                >Download <MdDownload /></button>
                            }

                            {isAuthenticated &&
                                <a href={`/generate-download/${slugUrl}?ad_free=true`} className="btn btn-link rounded-4" style={{ width: '100%' }} target={'_blank'}>Ad-free for <span class="special-text">1 point</span></a>
                            }

                        </div>
                    </div>
                </div>
            </div>

            <SkipAdsModal
                setShowSkipAdsModal={setShowSkipAdsModal}
                show={showSkipAdsModal}
                slugUrl={slugUrl}
            />
        </>
    )
}

export default ModelCard